import { render, staticRenderFns } from "./personal.html?vue&type=template&id=899c164c&scoped=true&"
import script from "./personal.vue?vue&type=script&lang=ts&"
export * from "./personal.vue?vue&type=script&lang=ts&"
import style0 from "./personal.scss?vue&type=style&index=0&id=899c164c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "899c164c",
  null
  
)

export default component.exports